import { ActionStatus } from '@/core/types/enums/action-status.enum'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { loginAction } from '../../actions/login.action'
import { useEmailAuthStore } from '../../store/email-auth'
import { loginSchema } from '../../types/dtos/login.dto'

export const useLogin = ({ onSuccess }: { onSuccess: () => void }) => {
  const { setEmail } = useEmailAuthStore()

  const form = useForm({
    defaultValues: { email: '', password: '' },
    resolver: zodResolver(loginSchema),
  })

  const [isPending, startTransition] = useTransition()

  const handleSubmit = form.handleSubmit(data => {
    startTransition(async () => {
      const { error, status } = await loginAction(data)

      if (status === ActionStatus.SUCCESS) {
        setEmail(data.email)
        onSuccess()
      }

      if (error) {
        form.setError('email', { message: error })
      }
    })
  })

  return { form, handleSubmit, isPending }
}
